<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0 justify-content-between d-flex">
        <audio src="../../../../assets/alarm.mp3" id="voice" ref="voice" controls hidden></audio>
        <h5 class="card-title font-bold py-3">
          نمایش درخواست های
          {{ seller && seller.full_name ? seller.full_name : "..." }}
        </h5>
        <div style="flex: 1"></div>
        <button class="btn ml-2" @click="enableSoundPlayback"
          :class="!interactionEnabled ? ' btn-danger' : 'btn-success'">
          <span v-if="interactionEnabled">
            آلارم فعال میباشد
          </span>
          <span v-else>
            آلارم غیر فعال میباشد
          </span>
        </button>
        <router-link :to="`/admin/change-status-all-sellers?type=return`
          " class="btn"
          style="color: #fff;background-color: rgb(173 31 31 / 77%);border-color: rgb(211 215 215 / 63%);">
          بازگشت تنوع ها
        </router-link>
        <!-- <router-link :to="`/admin/change-status-all-sellers?type=all`
          " class="btn mr-2" style="color: #fff;background-color: #83c7b4;border-color: rgb(211 215 215 / 63%);">
          ارسال همه‌ی تنوع های جدید
          <span class="bg-dot">{{ numberListItem(sellerRequests.data) }}</span>
        </router-link> -->

      </div>
      <div class="content-btn-filter">
        <button class="btn-filter badge" @click="filterStatus(filter)" v-for="(filter, index) in filterBtns"
          :key="filter.id ? filter.id : index" :class="filterActive == filter.status ? filter.style : ''">
          {{ filter.title }}
        </button>
      </div>
      <div class="card-body">
        <form class="mt-3" @submit.prevent="requestProduct">
          <div class="row justify-content-center">
            <b-form-group label="ارسال تنوع" class="col-3">
              <b-form-input autocomplete="off" autofocus ref="productSku" v-model="productSku"
                @keypress.prevent.enter="requestProduct" :disabled="disabled" type="text" />
            </b-form-group>
          </div>
        </form>
        <Loading v-if="loader" />
        <div v-else>
          <div v-if="sellerRequests && sellerRequests.data.length">
            <div class="content-card">
              <article v-for="(item, index) in sellerRequests.data" :key="index" class="card">
                <figure class="image-card">
                  <img :src="item.image && item.image.length ? item.image[0].url : ''" alt="" />
                  <div class="status-box">
                    <!-- <p>
                      <span>تاریخ درخواست فروشنده به انبار :</span>
                      <span>

                        {{ item.created_at | persianDate }}
                      </span>
                    </p>
                    <p>
                      <span>تاریخ ارسال انبار به فروشنده :</span>
                      <span>

                        {{ item.sent_at | persianDate }}
                      </span>
                    </p> -->
                    <p>
                      <span v-if="item.status == 'pending'" class="badge badge-warning status">جدید</span>
                      <span v-else-if="item.status == 'sent'" class="badge badge-secondary status">ارسال شده</span>
                      <span v-else-if="item.status == 'sold'" class="badge badge-success status">فروخته شده</span>
                      <span v-else-if="item.status == 'checked'" class="badge badge-info status">بررسی شده</span>
                      <span v-else class="badge badge-danger status">برگشت داده شده</span>
                    </p>
                  </div>
                </figure>
                <div class="info">
                  <h3 class="title">
                    {{ item.product_title }}
                  </h3>

                  <ul class="info-list">


                    <template v-if="
                      item.variety &&
                      item.variety.attributes &&
                      item.variety.attributes.length
                    ">
                      <div class="varieties-box">

                        <li v-for="(attribute, index) in item.variety.attributes"
                          :key="attribute.id ? attribute.id : index">
                          <span>
                            {{ `${attribute.label} :` }}
                          </span>
                          <b>
                            {{ attribute.pivot.value }}
                          </b>
                        </li>
                      </div>
                    </template>
                    <li v-if="item.var_barcode">
                      <span>بارکد :</span>
                      <b>
                        {{ item.var_barcode }}
                      </b>
                    </li>
                    <li v-if="item && item.seller && item.seller.full_name">
                      <span>نام فروشنده :</span>
                      <b>
                        {{ item.seller.full_name }}
                      </b>
                    </li>
                  </ul>
                  <div class="mt-2">
                    <p>
                      <span>تاریخ درخواست فروشنده به انبار :</span>
                      <b>

                        {{ item.created_at | persianDate }}
                      </b>
                    </p>
                    <p class="mt-2">
                      <span>تاریخ ارسال انبار به فروشنده :</span>
                      <b>

                        {{ item.sent_at | persianDate }}
                      </b>
                    </p>
                  </div>
                </div>
              </article>
            </div>
            <div class="flex-row justify-content-center">

              <pagination :router="true" v-if="sellerRequests && sellerRequests.data != ''" :disabled="disabled"
                :limit="2" :data="sellerRequests" @pagination-change-page="changePage" />
            </div>
          </div>
          <h4 v-else class="text-center mt-4 font-bold">درخواستی وجود ندارد</h4>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import SellerDetailImpl from "@@/core/pages/SalesManagement/SalesManagementsList/SellersImpl";
export default {
  extends: SellerDetailImpl,
};
</script>
<style scoped src="@@/core/pages/SalesManagement/SalesManagementsList/SellersStyle.css"></style>
<style>
.table-responsive-sm {
  height: auto !important;
}
</style>
